import { useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";

import { governanceConfigurations } from "../../../common/constants/clubs-wizard.constants";
import { GovernanceConfigurationType } from "../../../common/enums/clubs-wizard.enum";
import {
  IConfigurationItem,
  ICreateClubWizardForm,
} from "../../../common/interfaces/clubs-wizard.interface";
import formModel from "../../../pages/CreateClubWizardPage/formConfig";
import ConfigurationItems from "../../ConfigurationItems/ConfigurationItems";
import WizardHeader from "../WizardHeader/WizardHeader";

import "./GovernanceConfiguration.scss";

const GovernanceConfiguration: FC = () => {
  const { setFieldValue, values } = useFormikContext<ICreateClubWizardForm>();
  const [activeConfig, setActiveConfig] = useState(
    governanceConfigurations.find((item) => item.name === values.governance) ||
      governanceConfigurations[0]
  );

  useEffect(() => {
    initialSetupForDifferentGovernances();
  }, [activeConfig]);

  const initialSetupForDifferentGovernances = () => {
    if (activeConfig.name === GovernanceConfigurationType.ProjectFundraise) {
      setFieldValue(formModel.formFields.investor.name, true);
      setFieldValue(formModel.formFields.curator.name, false);
      setFieldValue(formModel.formFields.member.name, false);
    } else {
      setFieldValue(formModel.formFields.member.name, true);
      setFieldValue(formModel.formFields.investor.name, false);
    }
  };

  const setGovernanceConfiguration = (item: IConfigurationItem) => {
    setFieldValue("governance", item.name);
    setActiveConfig(item);
  };

  return (
    <div className="governance-configuration">
      <WizardHeader description="Choose your club’s governance model. Each governance model is comprised of two things: Voting power and Ownership. They will vary based on the model you choose. Read more below." />
      <ConfigurationItems
        activeConfig={activeConfig}
        changeSelectedConfigItem={setGovernanceConfiguration}
        configurationItems={governanceConfigurations}
      />
    </div>
  );
};

export default GovernanceConfiguration;
